import { defineMessages } from 'react-intl';

export default defineMessages({

    rateAsOfDate: {
        id: 'rewrite.ea.views.ea-policy-info.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    }
});
